import PreviewVideoModel from "./preview-video/PreviewVideoModel.js";

export default class MockupPreviewVideoModel {
  constructor({
    id = null,
    order = null,
    active = true,
    scale = 1,
    translateX = 0,
    translateY = 0,
    destroy = false,

    previewVideo = {},
    stores = [],
  }) {
    this.id = id;
    this.jsClass = "MockupPreviewVideoModel";
    this.order = order;
    this.active = active;
    this.scale = scale;
    this.translateX = translateX;
    this.translateY = translateY;
    this.destroy = destroy;

    this.previewVideo = this.mountPreviewYoutubeVideo(previewVideo || {});
    this.stores = stores;
  }

  json = () => {
    return {
      id: this.id,
      jsClass: this.jsClass,
      order: this.order,
      active: this.active,
      scale: this.scale,
      translateX: this.translateX,
      translateY: this.translateY,
      destroy: this.destroy,

      previewVideo: this.previewVideo.json(),
      stores: this.stores,
    };
  };

  mountPreviewYoutubeVideo = (previewVideo) =>
    new PreviewVideoModel(previewVideo);

  addPreviewYoutubeVideo = (hash) => this.previewVideo.updateValues(hash);
}
